<!-- 到店有礼 -->
<template>
<div style="margin: 20px 0 0 50px;">
  <div style="margin-bottom: 20px;">
    <span>到店有礼：</span> <el-switch v-model="yyisOpen" active-color="#138cdd" inactive-color="#999999" :change="handleSwitch()"/>
  </div>
  <div style="margin-left: 75px;">
    <el-input v-model="ActivityContent" placeholder="输入礼品名称，不超过10个汉字" maxlength="10"
    style="width:30%;display: block;"/>
    <!-- <el-input type="textarea" v-model="ActivityContent" style="width:650px;"
      :autosize="{ minRows: 2, maxRows: 6}" maxlength="500" show-word-limit/> -->
    <div class="upload" style="display:block; margin-top: 15px;">
      <el-upload class="avatar-uploader" action :show-file-list="false" :before-upload="beforeCoverOfDecoration">
        <img :src="coverImageUrlOne" v-if="coverImageUrlOne" style="width:80px;height:80px"/>
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <div style="color:#888;margin-top: 10px;">请上传礼品图片建议尺寸：1比1 ，支持的图片格式，jpg、png。</div>
    </div>
  </div>
  <div style="text-align:center;margin-bottom: 20px;">
    <el-button @click="goback()">取消</el-button>
    <el-button type="danger" @click="emit()">确定</el-button>
  </div>
</div>
</template>
<script>
import { uploadOSS } from '../../utils/oss';
import { getOssFile } from '../../api/newOss';
import { getStoreGift, putStoreGift } from "../../api/shopWindow";
export default {
  name: "ddyl",
  data() {
    return {
      yyisOpen: false, // 是否开启店铺有礼
      ActivityContent: "", // 预约有礼
      // 礼品图片
      coverImageUrlOne: "",
      coverImageUrlOneQiege: "",
      
    };
  },
  methods: {
    // 回显数据
    getinfobyId() {
      var obj = {
        bbid: localStorage.businessBbId
        // queryType: 3
      };
      getStoreGift(obj).then(data => {
        if (data.resultCode == 1) {
          this.shopinfo = data.resultObj;
          this.yyisOpen = this.shopinfo.isStoreGift; // 预约有礼开关
          this.ActivityContent = this.shopinfo.storeGift; // 预约有礼
          this.coverImageUrlOne = localStorage.BaseOssUrl + this.shopinfo.storeGiftImg; // 店铺有礼图片 - 全链接
          this.coverImageUrlOneQiege = this.shopinfo.storeGiftImg; // 店铺有礼图片 - 短连接
        }
      });
    },
    // 保存修改
    emit() {
      if (this.yyisOpen == true && (this.ActivityContent == "" || this.ActivityContent == null)) {
        this.$swal({
          type:"warning",
          text:"请输入礼品名称"
        })
        return false;
      }
      if (this.yyisOpen == true && (this.coverImageUrlOne == "" || this.coverImageUrlOne == null)) {
        this.$swal({
          type:"warning",
          text:"请上传礼品图片"
        })
        return false;
      }
      var obj = {
        // UserId: localStorage.Id,
        bbid: localStorage.businessBbId,
        isStoreGift: this.yyisOpen, // 是否开启店铺有礼
        storeGift: this.ActivityContent, // 店铺有礼内容
        storeGiftImg: this.coverImageUrlOneQiege, // 店铺有礼图片
      };
      putStoreGift(obj).then(data => {
        if (data.resultCode == 1) {
            this.$swal({
            type:"success",
            text:"保存成功"
          })
        }
      });
    },
    handleSwitch() {
      if(this.yyisOpen == false) {
        this.ActivityContent = '';
        this.coverImageUrlOne = '';
        this.coverImageUrlOneQiege = '';
      }
    },
    // 礼品图片
    beforeCoverOfDecoration(file) {
      const isJPG = file.type
      if (isJPG !='image/jpeg'&&isJPG !='image/png'){
        this.$swal({
          type:"warning",
          text:"上传图片格式应为jpg/png"
        })
        return false
      }
      const isSize = new Promise(function(resolve, reject) {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = function() {
          // let valid = img.width == width && img.height == height;
          let valid = img.width / img.height == 1; // 控制传正方形图片
          valid ? resolve() : reject();
        };
      })
      isSize.then(() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function(e) {
          /* oss 直传图片 */
          var obj = {
            type: 32
          };
          getOssFile(obj).then(data => {
            if (data.resultCode == 1) {
              let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
              let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
              let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
              let ossfile = data.resultObj.directory; // 保存路径
              let ossbucket = data.resultObj.bucket; // bucket
              localStorage.setItem('keyossId',ossId);
              localStorage.setItem('keyossSecret',ossSecret);
              localStorage.setItem('keyossHost',ossHost);
              localStorage.setItem('keyossfile',ossfile);
              localStorage.setItem('keyossbucket',ossbucket);
            }
          })
          var newOssPic = await uploadOSS(file,0);
          that.coverImageUrlOne = newOssPic;
          that.coverImageUrlOneQiege = newOssPic.replace(localStorage.BaseOssUrl,'')
        };
      },() => {
          this.$swal({
            type:"warning",
            text:"上传图片宽高比例应为1:1"
          })
        }
      );
    },
    // 返回
    goback(){
      this.$router.go(-1);
    },
  },
  mounted() {
    
  }
};
</script>
<style scoped>
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  border: 1px solid #eee;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// ddyl.vue?50a0c014